import React from 'react';
import './Input.css';

/**
 * Input Component
 * @param {string} label - Input label
 * @param {string} error - Error message
 * @param {React.ReactNode} icon - Icon to display inside input
 */
const Input = ({
    label,
    error,
    icon,
    className = '',
    id,
    ...props
}) => {
    const inputId = id || `input-${Math.random().toString(36).substr(2, 9)}`;

    return (
        <div className={`ui-input-wrapper ${className}`}>
            {label && (
                <label htmlFor={inputId} className="ui-input-label">
                    {label}
                </label>
            )}

            <div className="ui-input-container">
                {icon && <span className="ui-input-icon">{icon}</span>}
                <input
                    id={inputId}
                    className={`ui-input ${error ? 'ui-input-error' : ''} ${icon ? 'ui-input-with-icon' : ''}`}
                    {...props}
                />
            </div>

            {error && <span className="ui-input-error-msg">{error}</span>}
        </div>
    );
};

export default Input;
